import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { BuyVsSellOvertimeChart } from 'src/v2/views/owner-reveal/insights/portfolio-summary/buy-vs-sell-overtime/chart'
import { BuyVsSellOvertimeFilters } from 'src/v2/views/owner-reveal/insights/portfolio-summary/buy-vs-sell-overtime/filters'

export const BuyVsSellOvertime: FC = () => {
  return (
    <WidgetCard
      id="buy-vs-sell-overtime"
      title="Buy vs. Sell Overtime"
      headerBgColor={Colors.primaryRed700}
      headerTextColor={Colors.textWhite}
      filters={<BuyVsSellOvertimeFilters />}
      sections={[
        {
          content: <BuyVsSellOvertimeChart />,
        },
      ]}
    />
  )
}
